import styled from "styled-components";
import { FancyTitle } from "./components/fancyTitle";
import { useNuovoRistoranteQuery } from "../../generated/graphql";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import React from "react";
import { FancyButton } from "./components/button";
const BlockContainer = styled.div`
  display: flex;

  flex-direction: column;
  align-items: center;
  padding-bottom: 50px;
  img {
    height: 80px;
  }
  h3 {
    font-family: "Caviar Dreams";
    font-style: normal;
    font-weight: 700;
    text-align: center;
    letter-spacing: 0.26em;
    color: #a2a087;
  }
  p {
    max-width: 300px;
    height: 100px;
    text-align: center;
  }
`;
const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
  padding: 50px;

  @media (min-width: 1100px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (min-width: 1400px) {
    grid-template-columns: repeat(3, 1fr);
  }
`;
function Offer(props: {
  title: string;
  img: string;
  text?: React.ReactNode;
  menuLink?: string;
}) {
  return (
    <>
      <BlockContainer>
        <img src={props.img}></img>
        <h3>{props.title}</h3>

        <p>{props.text}</p>
        {props.menuLink && (
          <a href={props.menuLink}>
            <FancyButton>Menù</FancyButton>
          </a>
        )}
      </BlockContainer>
    </>
  );
}
export function Offerta() {
  const { data } = useNuovoRistoranteQuery();
  const { data: urlsData } = useNuovoRistoranteQuery();

  return (
    <>
      <FancyTitle text="Offerta" double />
      <Container>
        {
          <Offer
            title="MENU LUNCH"
            img="/kum/tie.webp"
            text={documentToReactComponents(
              data?.nuovoRistorante?.loungeBar?.json,
            )}
            menuLink={urlsData?.nuovoRistorante?.menuLunch?.url as string}
          />
        }
        {
          <Offer
            title="SNACK"
            img="/kum/fork.webp"
            text={documentToReactComponents(
              data?.nuovoRistorante?.allDayDining?.json,
            )}
            menuLink={urlsData?.nuovoRistorante?.menuAllDay?.url as string}
          />
        }
        <Offer
          title="MENU DINNER"
          img="/kum/bell.webp"
          text={documentToReactComponents(data?.nuovoRistorante?.dinner?.json)}
          menuLink={urlsData?.nuovoRistorante?.menuDinner?.url as string}
        />
        <Offer
          title="BREAKFAST"
          img="/kum/breakfast.webp"
          text={documentToReactComponents(
            data?.nuovoRistorante?.breakfast?.json,
          )}
          menuLink={urlsData?.nuovoRistorante?.menu?.url as string}
        />
        <Offer
          title="BRUNCH"
          img="/kum/brunch.webp"
          text={documentToReactComponents(data?.nuovoRistorante?.brunch?.json)}
          menuLink={urlsData?.nuovoRistorante?.menuBrunch?.url as string}
        />
        <Offer
          title="DRINK LIST"
          img="/kum/drink.webp"
          text={documentToReactComponents(
            data?.nuovoRistorante?.drinklist?.json,
          )}
          menuLink={urlsData?.nuovoRistorante?.drinklistMenu?.url as string}
        />
      </Container>
    </>
  );
}
